import React, { useEffect, useState } from "react";
import ContainerWrapper from "../../hoc/containerWrapper";
import CreateAuction from "../../components/auctions/createAuction";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { omit } from "lodash";
import {
	createAuctionRequest,
	createAuctionReset,
} from "../../store/actions/createAuctionAction";
import { dateFormatDDMMYYYY } from "../../utils/dateFormatDDMMYYYY";
import Swal from "sweetalert2";
import { inv_table_header_arr } from "../../constants/inventoryListTableHeader";
import * as XLSX from "xlsx";

const CreateAuctionConatiner = () => {
	const [fields, setFields] = useState({
		auction_name: "",
		start_date: "",
		end_date: "",
		excel_file: null,
	});

	//console.log("fields",fields)

	const [errors, setErrors] = useState({});
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const loginObj = useSelector((state) => state.nbfcLoginReducer);
	const { loginResult } = loginObj;
	const createAuctionObj = useSelector((state) => state.createAuctionReducer);
	const { createAuctionResult } = createAuctionObj;
	//console.log("createAuctionObj",createAuctionObj)

	let errorReturn = {};
	let errorObj = errors;

	useEffect(() => {
		if (createAuctionResult) {
			Swal.fire({
				icon: "success",
				confirmButtonColor: "#652078",
				text: "Uploaded successfully",
			}).then((res) => {
				if (res) {
					dispatch(createAuctionReset());
					navigate("/auctionUploadedList");
				}
			});
		}
	}, [createAuctionResult]);

	// useEffect(() => {
	//   if (otpResult?.status && timer > 0) {
	//     const interval = setInterval(() => {
	//       setTimer(prevTimer => prevTimer - 1);
	//     }, 1000);

	//     return () => clearInterval(interval);
	//   }
	// }, [otpResult?.status]);

	const validate = (name, value) => {
		if (value === "" && name === "auction_name") {
			errorObj = { ...errorObj, [name]: "Please enter auction name." };
		} else if (
			value !== "" &&
			name === "auction_name" &&
			!/^[a-zA-Z][a-zA-Z0-9_ ]{2,49}$/.test(value)
		) {
			errorObj = { ...errorObj, [name]: "Please enter valid auction name." };
		} else if (value === "" && name === "start_date") {
			errorObj = { ...errorObj, [name]: "Please select start date." };
		} else if (value === "" && name === "end_date") {
			errorObj = { ...errorObj, [name]: "Please select end date." };
		} else if ((value === "" || !value) && name === "excel_file") {
			errorObj = { ...errorObj, [name]: "Please select file." };
		} else if (errors?.hasOwnProperty(name)) {
			let newObj = omit(errors, name);
			errorObj = newObj;
		}

		return errorObj;
	};

	const handleSubmitcreateAuction = (e) => {
		e.preventDefault();
		let defaultFieldJsonKey = Object.keys(fields);
		for (let i = 0; i < defaultFieldJsonKey.length; i++) {
			if (defaultFieldJsonKey) {
				errorReturn = validate(
					defaultFieldJsonKey[i],
					fields[defaultFieldJsonKey[i]]
				);
			}
		}
		//console.log("error", errors);
		if (Object.keys(errorReturn).length === 0 && Object.keys(errors).length === 0) {
			//console.log("submit", fields.excel_file);
			dispatch(createAuctionRequest({accessToken:loginResult?.access, auction_name: fields.auction_name, start_date:dateFormatDDMMYYYY(fields.start_date), end_date: dateFormatDDMMYYYY(fields.end_date), file:fields.excel_file,auction_group: loginResult?.group_name }));
		} else {
			setErrors(errorReturn);
		}
	};

	const validateExcel = (file) => {
		const reader = new FileReader();

		reader.onload = (e) => {
			const data = e.target.result;
		
			// Check file extension to determine the file format
			if (file.name.endsWith(".xlsx") || file.name.endsWith(".xls")) {
				const workbook = parseExcel(data);

				if (workbook) {
					// Validate columns and blank file
					if (validateColumns(workbook) && validateNotBlank(workbook)) {
						if (errors?.hasOwnProperty("excel_file")) {
							let newObj = omit(errors, "excel_file");
							setErrors(newObj);
						}
						//console.log('Valid Excel file. Ready for submission!');
					}
				} else {
					setErrors((prev) => ({
						...prev,
						excel_file:
							"Invalid Excel file. Please check the file and try again.",
					}));
					//console.log('Invalid Excel file. Please check the file and try again.');
				}
			} else {
				console.log("Unsupported file format");
			}
		};
		reader.readAsBinaryString(file);
		//console.log("end")
	};

	const validateColumns = (workbook) => {
		// Replace with your actual column names
		const requiredColumns = inv_table_header_arr;
		const headerRow = workbook;
		const firstRow = headerRow?.[0]?.map((header) =>
			header?.replace(/[\r\n]+/g, "")
		);

		const missingColumns = requiredColumns?.filter(
			(col) => !firstRow?.includes(col)
		);

		if (
			missingColumns.length > 0 ||
			firstRow.length !== requiredColumns.length
		) {
			setErrors((prev) => ({
				...prev,
				excel_file: "Invalid number or names of columns in the Excel file.",
			}));
			//console.log('Missing columns: ', errorObj);
			return false;
		} else if (errors?.hasOwnProperty("excel_file")) {
			let newObj = omit(errors, "excel_file");
			setErrors(newObj);
		}

		return true;
	};

	const validateNotBlank = (workbook) => {
		const sheet = workbook;
		const numberOfRowsToCheck = 10;
		const dataRowsToCheck = sheet?.slice(1, numberOfRowsToCheck);

		if (
			dataRowsToCheck.length === 0 ||
			dataRowsToCheck.filter((item) => item.length === 0).length === dataRowsToCheck.length
			) {
			const errorMessage =
			dataRowsToCheck.length === 0
			  ? "Empty data in the Excel file."
			  : "Some rows contain blank data. Please check the file.";
	  
			setErrors((prev) => ({
				...prev,
				excel_file: errorMessage,
			}));
			//console.log("Empty data in the Excel file");
			return false;
		} else if (errors?.hasOwnProperty("excel_file")) {
			let newObj = omit(errors, "excel_file");
			//console.log("else",dataRows)
			setErrors(newObj);
		}

		return true;
	};

	const parseExcel = (data) => {
		const workbook = XLSX.read(data, { type: "binary" });
		const sheetName = workbook.SheetNames[0];
		const sheet = workbook.Sheets[sheetName];
		const excelData = XLSX.utils.sheet_to_json(sheet, { header: 1 });
		return excelData;
	};

	const handleChange = (e) => {
		const { type, name, value, files } = e.target;
		errorReturn = validate(name, value);
		setErrors(errorReturn);
		if (type === "file") {
			setFields((prev) => ({
				...prev,
				[name]: files?.[0],
			}));
			validateExcel(files?.[0]);
		} else {
			setFields((prev) => ({
				...prev,
				[name]: value,
			}));
		}
	};
	//console.log("sett", errors)
	return (
		<CreateAuction
			handleChange={handleChange}
			handleSubmitcreateAuction={handleSubmitcreateAuction}
			auction_name={fields.auction_name}
			start_date={fields.start_date}
			end_date={fields.end_date}
			errors={errors}
		/>
	);
};

export default ContainerWrapper(CreateAuctionConatiner);
